import React from "react";
import LegalPage from "./LegalPage";

export default function Refund() {
  return (
    <LegalPage title="Refund &amp; Cancellation Policy" subtitle="Legal" testid="refund-page">
      <p>
        This Refund &amp; Cancellation Policy explains your rights in respect of payments made for the
        Breakout Scanner premium subscription.
      </p>

      <h2>1. Trial Charge (₹5 for 5 days)</h2>
      <ul>
        <li>
          The ₹5 trial is a <strong>non-refundable service activation fee</strong> charged to authorise the
          recurring mandate and unlock Premium content immediately.
        </li>
        <li>
          Because digital content is delivered the moment your trial starts, the trial fee is not refundable
          once the account has been activated.
        </li>
      </ul>

      <h2>2. Monthly Renewal (₹299/month)</h2>
      <ul>
        <li>
          After the 5-day trial, ₹299 is auto-charged every month until you cancel. You will receive a
          receipt from Razorpay for every successful charge.
        </li>
        <li>
          <strong>No refund is provided once a monthly renewal has been successfully charged.</strong> The
          paid cycle remains active for its full duration so you continue to receive Premium content.
        </li>
        <li>
          You may request a pro-rata refund only where the charge was clearly made in error (e.g. duplicate
          payment due to a technical glitch) by writing to{" "}
          <span className="font-mono">breakoutscanner1987@gmail.com</span> within 7 days of the charge.
        </li>
      </ul>

      <h2>3. How to Cancel</h2>
      <ol>
        <li>
          Open the in-app <em>Pricing</em> page (<span className="font-mono">/pricing</span>) and click{" "}
          <strong>&quot;Cancel subscription&quot;</strong>.
        </li>
        <li>
          Alternatively, cancel the auto-debit mandate from your bank or UPI app (NPCI / BHIM portal, or your
          UPI provider), or from the Razorpay customer portal.
        </li>
        <li>
          Cancellation takes effect at the <strong>end of the current billing cycle</strong> — you retain
          Premium access until then. No further charges will be made.
        </li>
      </ol>

      <h2>4. Refund Processing</h2>
      <ul>
        <li>
          Approved refunds are credited to the <strong>original payment method</strong> used at purchase.
        </li>
        <li>
          Bank/UPI: typically 5–7 business days. Cards: typically 7–14 business days.
        </li>
      </ul>

      <h2>5. Chargebacks &amp; Disputes</h2>
      <p>
        If you believe a charge is unauthorised, please contact us first at{" "}
        <span className="font-mono">breakoutscanner1987@gmail.com</span>. Initiating a chargeback without contacting us
        may result in your account being suspended while the dispute is investigated.
      </p>

      <h2>6. Failed Payments</h2>
      <p>
        If an auto-debit fails due to insufficient funds, an expired card, or mandate revocation, we will
        retry as per Razorpay&apos;s standard retry schedule. Your Premium access may be paused until a
        successful retry.
      </p>

      <h2>7. Service Issues</h2>
      <p>
        If the Service is materially broken or unavailable for more than 48 consecutive hours due to our fault
        (excluding scheduled maintenance), we will — at our discretion — extend your subscription by an
        equivalent period as a goodwill adjustment.
      </p>

      <h2>8. Contact</h2>
      <p>
        All refund or cancellation queries should be emailed to{" "}
        <span className="font-mono">breakoutscanner1987@gmail.com</span> with your registered email and the last 4
        digits of the payment instrument used.
      </p>
    </LegalPage>
  );
}
